import { PropsWithChildren } from 'react';
import { Switch as AriaSwitch, SwitchProps } from 'react-aria-components';
import styled from 'styled-components';
import { colors } from '../utils';

type Props = {
    isSelected: SwitchProps['isSelected'];
    onChange: SwitchProps['onChange'];
};

export function Switch({
    isSelected,
    onChange,
    children,
}: PropsWithChildren<Props>) {
    return (
        <StyledSwitch
            defaultSelected={isSelected}
            onChange={onChange}
            isSelected={isSelected}
        >
            <div className="indicator" />
            {children}
        </StyledSwitch>
    );
}

export const StyledSwitch = styled(AriaSwitch)`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    forced-color-adjust: none;

    .indicator {
        width: 3.125rem;
        height: 1.75rem;
        background: ${colors.greyscaleTextDisabled};
        border-radius: 1.143rem;
        transition: all 200ms;

        &:before {
            content: '';
            display: block;
            margin: 0.21875rem;
            width: 1.3125rem;
            height: 1.3125rem;
            background: ${colors.white};
            border-radius: 16px;
            transition: all 200ms;
        }
    }

    &[data-pressed] .indicator {
        background: ${colors.blue800};

        &:before {
            background: ${colors.white};
        }
    }

    &[data-selected] {
        .indicator {
            background: ${colors.white};

            &:before {
                background: ${colors.blue800};
                transform: translateX(100%);
            }
        }

        &[data-pressed] {
            .indicator {
                background: ${colors.white};
            }
        }
    }
`;
